(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/utils.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/utils.js');
const { formatOrgNumber } = svs.ticket_partner.utils;
const digitalOrderModel = {
  customer: {
    partnerId: 0,
    retailerStatus: 2,
    eMail: '',
    contactPerson: '',
    companyName: '',
    legalCompanyName: '',
    organizationNumber: '',
    phone: '',
    supportPhone: '',
    cellPhone: '',
    userTermsApproved: true,
    invoiceDueDays: 30,
    discountType: null,
    isPartner: false,
    addresses: []
  },
  order: {
    message: '',
    invoiceMessage: '',
    orderId: '',
    ordererType: 'Ftg',
    rows: []
  }
};

const createBillingObject = ({ reference, address1, zip, city, countryId, email }, { eMail, phone }) => {
  return {
    addressType: 'Billing',
    contact: reference,
    phone: phone || null,
    email: email || eMail,
    address1,
    address2: '',
    zip: zip.replaceAll(' ', ''),
    city,
    countryId: countryId
  };
};

const createOrder = (articles, invoiceMessage, message) => {
  return {
    invoiceMessage,
    message,
    ordererType: 'Ftg',
    orderId: '',
    rows: Object
      .values(articles)
      .map(({ articleId, count }) => ({ articleId, count: parseInt(count, 10) }))
      .filter(({ count }) => count > 0)
  };
};

const createDigitalOrderRequest = ({ billingInformation, registerNew, articles }, companyDetails = null) => {
  const { invoiceMessage, message } = billingInformation;
  const { contactPerson, phone, eMail, organizationNumber } = registerNew;
  const billing = createBillingObject(billingInformation, registerNew);
  const order = createOrder(articles, invoiceMessage, message);
  if (companyDetails) {
    const addresses = companyDetails.addresses.map((address) => {
      if (address.addressType.toLowerCase() === 'billing') {
        return {
          ...address,
          ...billing,
          address2: address.address2 || '',
          email: billing.email || address.email,
          phone: address.phone
        };
      }
      return address;
    });
    return {
      ...digitalOrderModel,
      customer: {
        ...digitalOrderModel.customer,
        ...companyDetails,
        addresses,
        invoiceDueDays: digitalOrderModel.customer.invoiceDueDays
      },
      order
    };
  }
  const addresses = ['Billing', 'Legal', 'Visiting'].map((addressType) => {
    if (addressType === 'Billing') {
      return billing;
    }
    return {
      ...billing,
      addressType,
      contact: contactPerson,
      email: eMail || ''
    };
  });

  return {
    ...digitalOrderModel,
    customer: {
      ...digitalOrderModel.customer,
      ...registerNew,
      organizationNumber: formatOrgNumber(organizationNumber.replace('-', ''), false),
      supportPhone: phone,
      addresses
    },
    order
  };
};

svs.ticket_partner.digitalTickets.utils = {
  createDigitalOrderRequest
};



 })(window);